export const menuItemKeySplitChar = '.';
export const menuItemKeyParam = 'mik';
